/**
 * Shared connected-provider catalog + in-process disconnect set.
 * Used by provider detail and instance detail mocks so the slug list cannot drift.
 */

export const CONNECTED_PROVIDERS = {
  slack: {
    name: 'Slack',
    category: 'Communication',
    official: true,
    auth: 'oauth',
    vendor: 'slack.com',
    instances: ['working', 'working'],
  },
  salesforce: {
    name: 'Salesforce',
    category: 'CRM & Sales',
    official: true,
    auth: 'oauth',
    vendor: 'salesforce.com',
    instances: ['schema_drift', 'working'],
  },
  zendesk: {
    name: 'Zendesk',
    category: 'Ticketing & ITSM',
    official: true,
    auth: 'api_key',
    vendor: 'zendesk.com',
    instances: ['auth_expired'],
  },
  'google-drive': {
    name: 'Google Drive',
    category: 'Storage',
    official: true,
    auth: 'oauth',
    vendor: 'drive.google.com',
    instances: ['auth_expired', 'working'],
  },
  notion: {
    name: 'Notion',
    category: 'Productivity & Docs',
    official: true,
    auth: 'oauth',
    vendor: 'notion.so',
    instances: ['schema_drift'],
  },
  github: {
    name: 'GitHub',
    category: 'Dev & Code',
    official: true,
    auth: 'oauth',
    vendor: 'github.com',
    instances: ['working'],
  },
  snowflake: {
    name: 'Snowflake',
    category: 'Data & Analytics',
    official: true,
    auth: 'key_pair',
    vendor: 'snowflake.com',
    instances: ['working'],
  },
  // Kept in sync with `integrationsService` (the "Already Integrated" catalog):
  // every connected integration there must resolve to a connected provider detail.
  datadog: {
    name: 'Datadog',
    category: 'Security & Observability',
    official: true,
    auth: 'api_key',
    vendor: 'datadoghq.com',
    instances: ['schema_drift'],
  },
  jira: {
    name: 'Jira',
    category: 'Ticketing & ITSM',
    official: true,
    auth: 'oauth',
    vendor: 'atlassian.com',
    instances: ['needs_mapping'],
  },
  'amazon-s3': {
    name: 'Amazon S3',
    category: 'Storage',
    official: true,
    auth: 'api_key',
    vendor: 'aws.amazon.com',
    instances: ['needs_mapping', 'working'],
  },
  linear: {
    name: 'Linear',
    category: 'Productivity & Docs',
    official: true,
    auth: 'oauth',
    vendor: 'linear.app',
    instances: ['working'],
  },
  'internal-billing-api': {
    name: 'Internal Billing API',
    category: 'Custom / Build your own',
    official: false,
    auth: 'api_key',
    vendor: null,
    instances: ['needs_mapping'],
  },
  spreadsheet: {
    name: 'Spreadsheet',
    category: 'Custom / Build your own',
    official: true,
    auth: 'oauth',
    vendor: null,
    instances: ['working'],
  },
};

/** Slugs disconnected during this process (CT-4187). */
let disconnectedSlugs = new Set();

export const isProviderDisconnected = (slug) => disconnectedSlugs.has(slug);

export const markProviderDisconnected = (slug) => {
  disconnectedSlugs.add(slug);
};

/** Test-only: restore all providers to their seed connection state. */
export const __resetMockProvidersForTests = () => {
  disconnectedSlugs = new Set();
};
